exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collapse.is-fullwidth{width:100%}", ""]);

// exports
